// extracted by mini-css-extract-plugin
export var bubble = "_40-0";
export var container = "_40-f";
export var contrastBorder = "_40-g";
export var greyOut = "_40-2";
export var initialsColor0 = "_40-3";
export var initialsColor1 = "_40-4";
export var initialsColor10 = "_40-d";
export var initialsColor11 = "_40-e";
export var initialsColor2 = "_40-5";
export var initialsColor3 = "_40-6";
export var initialsColor4 = "_40-7";
export var initialsColor5 = "_40-8";
export var initialsColor6 = "_40-9";
export var initialsColor7 = "_40-a";
export var initialsColor8 = "_40-b";
export var initialsColor9 = "_40-c";
export var initialsWrapper = "_40-1";
export var large = "_40-l";
export var medium = "_40-k";
export var mediumSmall = "_40-j";
export var mediumSmallMedium = "_40-o";
export var micro = "_40-h";
export var small = "_40-i";
export var tiny = "_40-n";
export var xTiny = "_40-m";